<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

(function () {
  const collabsTranslations = {
    'Already a member?': 'Ai deja un cont?',
    'Log in': 'Autentifică-te',
    'Partnership opportunities': 'Oportunități de colaborare',
    'Affiliate marketing': 'Marketing afiliat',
    'Discount codes': 'Coduri de reducere',
    'Campaigns': 'Campanii',
    'Content creation': 'Creare de conținut',
    'Additional opportunities': 'Alte oportunități'
  };

  const collabsSelectors = [
    '.collabs-page__cta-login-section p',
    '.collabs-page__cta-login-link',
    '.collabs-page__partnership h2',
    '.collabs-page__partnership-list li'
  ].join(',');

  function translateCollabs(root = document) {
    root.querySelectorAll(collabsSelectors).forEach(function (element) {
      const originalText = element.textContent.trim();
      const translatedText = collabsTranslations[originalText];

      if (translatedText) {
        element.textContent = translatedText;
      }
    });
  }

  function initCollabsTranslations() {
    translateCollabs();

    /*
     * În Theme Editor, Shopify poate re-randa dinamic
     * secțiunile fără refresh complet.
     */
    document.addEventListener('shopify:section:load', function (event) {
      translateCollabs(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollabsTranslations);
  } else {
    initCollabsTranslations();
  }
})();